export default class Form {
  constructor({ elm, app }) {
    this.app = app;
    this.elm = elm;
    // this.hideClassName = this.node.dataset.hideClass;
  }
}
